// Module
var code = ` <div ng-switch="datepickerMode"> <div uib-daypicker ng-switch-when="day" tabindex="0" class="uib-daypicker" template-url="/common/datepicker/touch/daypickerTemplate.html"> </div> </div> `;
// Exports
var _module_exports =code;;
var path = '/common/datepicker/touch/datepickerTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;